import { Component } from '@angular/core';
import { CoreBuildingBlockControlBaseComponent } from '../../shared/building-block-control-base.component';
import { CoreBuildingBlock } from '../../shared/building-block.decorator';

@CoreBuildingBlock('button')
@Component({
  selector: 'cu-button',
  templateUrl: './button.component.html'
})
export class ButtonComponent extends CoreBuildingBlockControlBaseComponent {
  onClick(clickEvent: Event) {
    if (this.field.enabled) {
      super.onClick(clickEvent);
    }
    clickEvent.preventDefault();
  }
}
